/**
 * WordPress dependencies
 */
import type { WordPressComponentProps } from '@safe-wordpress/components';

/**
 * Internal dependencies
 */
import { PointerCircle } from './styles/focal-point-style';

/**
 * External dependencies
 */
import type { FocalPointProps } from './types';

export default function FocalPoint( {
	left = '50%',
	top = '50%',
	...props
}: WordPressComponentProps< FocalPointProps, 'div' > ): JSX.Element {
	const style = { left, top };

	return (
		<PointerCircle
			{ ...props }
			className="components-focal-point-picker__icon_container"
			style={ style }
		/>
	);
}
